import React, { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import cx from "classnames";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import styles from "./BottomNav.module.scss";

const tabs = [
  { path: "/mobile", icon: ICONS.HOME, label: "Home", exact: true },
  { path: "/mobile/schedule", icon: ICONS.MY_SCHEDULE, label: "Schedule" },
  { path: "/mobile/liked", icon: ICONS.LIKE_NAVBAR, label: "Liked" },
  { path: "/mobile/playlists", icon: ICONS.MY_PLAYLIST, label: "Playlists" },
  { path: "/mobile/profile", icon: ICONS.PROFILE, label: "Profile" },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (tab) => {
    if (tab.exact) return pathname === tab.path;
    return pathname.startsWith(tab.path);
  };

  return (
    <nav className={styles.nav}>
      {tabs.map((tab) => (
        <button
          key={tab.path}
          className={cx(styles.tab, { [styles.active]: isActive(tab) })}
          onClick={() => navigate(tab.path)}
        >
          <div className={styles.icon}>
            <Icons type={tab.icon} fill={isActive(tab) ? "#111111" : "#949494"} />
          </div>
          <span className={styles.label}>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default memo(BottomNav);
